// src/hooks/useChatHub.js
import { useState, useEffect, useCallback } from "react";
import * as signalR from "@microsoft/signalr";

const useChatHub = (session, onReceiveMessage) => {
  const [connection, setConnection] = useState(null);

  // Initialize the connection once.
  useEffect(() => {
    const newConnection = new signalR.HubConnectionBuilder()
      .withUrl("https://lanesands.io/ChatHub")
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);

    return () => {
      newConnection.stop();
    };
  }, []);

  // Start the connection and set up event handlers.
  useEffect(() => {
    if (connection) {
      // Only start if it's disconnected.
      if (connection.state === signalR.HubConnectionState.Disconnected) {
        connection
          .start()
          .then(() => {
            //console.log("Connected to ChatHub!");
            // Join a room if session info is available.
            if (session && session.roomNumber) {
              connection
                .invoke("JoinRoom", session.roomNumber)
                .catch((err) =>
                  console.error("Error joining room:", err.toString())
                );
            }
          })
          .catch((err) => console.error("Connection error:", err));
      }

      // Set up the ReceiveMessage event handler.
      connection.on("ReceiveMessage", (sender, text, timestamp) => {
        //console.log("Message received:", sender, text, timestamp);
        if (onReceiveMessage) {
          onReceiveMessage({ sender, text, timestamp });
        }
      });
    }
  }, [connection, session, onReceiveMessage]);

  // Function to send a message.
  const sendMessage = useCallback(
    (room, sender, text) => {
      if (connection) {
        connection
          .invoke("SendMessage", room, sender, text)
          .catch((err) => console.error("SendMessage error:", err));
      }
    },
    [connection]
  );

  return { sendMessage };
};

export default useChatHub;
